/**
 * Sticky Video
 * @module stickyVideo
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
export const PLUGIN_NAME = 'stickyVideo';
/**
 * Defines default configuration for stick video.
 * @type {Object}
 */
export const DEFAULTS = {};
/**
 * CSS className used for the container.
 * @type {string}
 */
export const CONTAINER_CLASS_NAME = 'sticky-video';
/**
 * CSS className used for the video wrap.
 * @type {string}
 */
export const WRAP_CLASS_NAME = `${CONTAINER_CLASS_NAME}__wrap`;
/**
 * CSS className used for fixed video wrap.
 * @type {string}
 */
export const FIXED_WRAP_CLASS_NAME = `${CONTAINER_CLASS_NAME}__wrap--fixed`;/**
 * CSS className used for stopped video wrap.
 * @type {string}
 */
export const STOPPED_WRAP_CLASS_NAME = `${CONTAINER_CLASS_NAME}__wrap--stopped`;
/**
 * CSS className used for the video iframe.
 * @type {string}
 */
export const IFRAME_CLASS_NAME = `${CONTAINER_CLASS_NAME}__iframe`;
/**
 * Vimeo API
 * @type {string}
 */
export const VIMEO_API_URL = 'https://player.vimeo.com/api/player.js';
/**
 * YouTube API
 * @type {string}
 */
export const YOUTUBE_API_URL = 'https://www.youtube.com/iframe_api';
/**
 * Video Width when fixed
 * @type {string}
 */
export const FIXED_VIDEO_WIDTH = 300;
/**
 * Add selected class to selected thumbnail
 * @param {jQuery} $thumbnail - jQuery object for thumbnail
 */
const nowPlayingMessage = ($thumbnail) => {
  const selectedClass = 'beautyshop__thumbnail-selected';
  $(`.${selectedClass}`).removeClass(selectedClass);
  $thumbnail.addClass(selectedClass);
}
/**
 * Reset video position
 * @private
 * @param  {jQuery} wrap - sticky wrap element
 * @param  {number} video width
 */
const unfixedVideo = (wrap, videoWidth) => {
  wrap.removeClass(FIXED_WRAP_CLASS_NAME).css({
    position: "absolute",
    width: videoWidth,
    top:0,
    left:0,
    opacity: 0
  }).stop().animate({
    opacity: 1,
  },600, function(){
    wrap.removeAttr("style");
  });
}
/**
 * Fixed video at the bottom
 * @private
 * @param  {jQuery} wrap - sticky wrap element
 */
const fixedVideoBottom = (wrap) => {
  wrap.addClass(`${FIXED_WRAP_CLASS_NAME} stick`).css({
    position: "fixed",
    height: 'initial',
    top: 'initial',
    bottom: 200,
    zIndex: 8,
    opacity: 0,
    left: 20,
    width: FIXED_VIDEO_WIDTH
  }).stop().animate({
    opacity: 1
  },700);
}
/**
 * Fixed video at the bottom
 * @private
 * @param  {jQuery} wrap - sticky wrap element
 * @param  {number} videoHeight - height of video
 * @param  {number} navBottomPosition - navigation bottom position
 */
const fixedVideoTop = (wrap, videoHeight, navBottomPosition) => {
  wrap.addClass(`${FIXED_WRAP_CLASS_NAME} stick`).css({
    position: "fixed",
    height: videoHeight,
    top: navBottomPosition+115,
    zIndex: 8,
    opacity: 0,
    left: 20,
    width: FIXED_VIDEO_WIDTH
  }).stop().animate({
    opacity: 1
  },700);
}
/**
 * Handle video stickiness
 * @param  {object} stickyOpts - object of sticky elements
 * @see DEFAULTS
 */
const stickyVideoFunctionality = ({videoContainer, wrap, iframe, player}) => {
  const $nav = $(".site-header .nav__wrapper");
  const videoHeight = videoContainer.outerHeight(true);
  const videoWidth = videoContainer.width();

  $(window)
  .off('scroll.stickyVideo')
  .on('scroll.stickyVideo', function() {
    const scrollPos = $(this).scrollTop();
    const navOffset = $nav.offset();
    const videoOffSet = videoContainer.offset();
    const videoTopPosition = videoOffSet.top - scrollPos;
    const videoBottomPosition = videoOffSet.top - scrollPos - $(window).height();
    const isHeaderFixed = $('.js-fixed-header-wrap').hasClass('is-fixed');
    const videoDownLimit = videoHeight * .85;
    const videoUpLimit = -1 * (videoHeight - videoDownLimit);
    const navBottomPosition = isHeaderFixed ? navOffset.top - scrollPos + $nav.height(): 0;
    const isVideoAboveView = isHeaderFixed ? navBottomPosition >= videoTopPosition + videoDownLimit: -1 * (videoTopPosition) >= videoDownLimit;
    const isVideoBelowView = videoBottomPosition >= videoUpLimit;
    const isFixed = wrap.hasClass(FIXED_WRAP_CLASS_NAME);
    const isStopped = wrap.hasClass(STOPPED_WRAP_CLASS_NAME);

    if (!isStopped && !isFixed) {
      if (isVideoAboveView) {
        fixedVideoTop(wrap, videoHeight, navBottomPosition);
      }
      if (isVideoBelowView) {
        fixedVideoBottom(wrap);
      }
    }
    if (isFixed && !isVideoAboveView && !isVideoBelowView) {
      unfixedVideo(wrap, videoWidth);
      if (isStopped) {
        $(window).off('scroll.stickyVideo');
      }
    }
  });
}
/**
 * Player on play handler
 * @private
 * @param  {object} stickyOpts - object of sticky elements
 */
const onPlay = (stickyOpts) => {
  const {wrap} = stickyOpts;
  wrap.removeClass(STOPPED_WRAP_CLASS_NAME);
  stickyVideoFunctionality(stickyOpts);
};
/**
 * Player on stop handler
 * @private
 * @param  {object} stickyOpts - object of sticky elements
 */
const onStop = ({wrap}) => {
  wrap.addClass(STOPPED_WRAP_CLASS_NAME);
};
/**
 * Apply Event Handler to load video
 * @param  {object} stickyOpts - object of sticky elements
 * @see DEFAULTS
 */
const applyEventHandlers = (stickyOpts) => {
  const {container} = stickyOpts;
  const $loadVideoTrigger = container.find('.js-load-video');
  $loadVideoTrigger.on('click', function(evt) {
    loadNewVideo($(this), stickyOpts);
    $('#js-video').focus();
  });
}
/**
 * Set up Vimeo player event
 * @private
 * @param  {object} stickyOpts - object of sticky elements
 */
const setVimeoEvents = (stickyOpts) => {
  const {player} = stickyOpts;
  applyEventHandlers(stickyOpts);
  player.on('play', () => {
    onPlay(stickyOpts);
});
  player.on('pause', () => {
    onStop(stickyOpts);
});
};
/**
 * Clean title for GA tracking
 * @private
 * @param  {object} stickyOpts - object of sticky elements
 * @return {string} unique id for youtube initialization
 */
const createUniqueID = ({iframe}) => {
  const ytid = `yt-${Math.ceil(Math.random() * 10000000000)}`;
  iframe.attr('id', ytid);
  return ytid;
};
/**
 * Check Vimeo auto play
 * @private
 * @param  {object} stickyOpts - object of sticky elements
 * @param  {event} youtube play event
 */
const checkVimeoAutoplay = ({iframe, player}) => {
  let autoplay = iframe.data('autoplay');
  if (autoplay) {
    player.ready().then(function() {
      player.play();
    });
  }
}
/**
 * Check YouTube auto play
 * @private
 * @param  {object} stickyOpts - object of sticky elements
 * @param  {event} youtube play event
 */
const checkYouTubeAutoPlay = ({iframe}) => (event) => {
  let autoplay = iframe.data('autoplay');
    if (autoplay) {
      event.target.playVideo();
    }
};
/**
 * Set up YouTube player event
 * @private
 * @param  {event} youtube play event
 */
const setYouTubeEvents = (stickyOpts) => (event) => {
  switch (event.data) {
    case 1:
      onPlay(stickyOpts);
      break;
    case 2:
      onStop(stickyOpts);
      break;
    default:
  }
};
/**
 * Init YouTube Player
 * @private
 * @param  {jQuery} $el - iframe of video to track
 * @param  {object} stickyOpts - object of sticky elements
 */
const initYouTubeVideo = (stickyOpts) => {
  const ytid = createUniqueID(stickyOpts);
  const setYTEvents = setYouTubeEvents(stickyOpts);
  applyEventHandlers(stickyOpts);
  const ytCheckAutoPlay = checkYouTubeAutoPlay(stickyOpts);
  return new YT.Player(ytid, {
    events: {
      onReady: ytCheckAutoPlay,
      onStateChange: setYTEvents,
    },
  });
};
/**
 * Setup players for respective video sources
 * @private
 * @param  {object} stickyOpts - object of sticky elements
 */
const setupPlayer = (stickyOpts) => {
  const {iframe} = stickyOpts;
  if (playerType(iframe, 'vimeo')) {
    const vimeoPlayer = new Vimeo.Player(iframe);
    const opts = Object.assign({}, stickyOpts, {player: vimeoPlayer});
    setVimeoEvents(opts);
    checkVimeoAutoplay(opts);
  } else if (playerType(iframe, 'youtube')) {
    if (window.youtubeLoaded) {
      const ytPlayer = initYouTubeVideo(stickyOpts);
      const opts = Object.assign({}, stickyOpts, {player: ytPlayer});
    }
    $(window).on('youtubeLoaded', () => {
      const ytPlayer = initYouTubeVideo(stickyOpts);
      const opts = Object.assign({}, stickyOpts, {player: ytPlayer});
    });
  }
};
/**
 * Attach a new a video base on selection
 * @param  {jQuery} $trigger - the element that triggers this function
 * @param  {object} stickyOpts - object of sticky elements
 * @see DEFAULTS
 */
const loadNewVideo = ($trigger, stickyOpts) => {
  const {container, iframe} = stickyOpts;
  const videoUrl = $trigger.data('video-url');
  const videoTitle = $trigger.children('.js-video-title').text();
  const $stickyIframeWrap = container.find('.sticky-video__iframe-wrap');
  const newVideoIFrame = `
    <iframe id="js-video" class="${IFRAME_CLASS_NAME}"
    src="${videoUrl}?autoplay=1"
    width="100%"
    height="100%"
    title="${videoTitle}"
    data-autoplay="true"
    frameborder="0"
    webkitallowfullscreen
    mozallowfullscreen
    allowfullscreen>
    </iframe>
  `;
  $stickyIframeWrap.html(newVideoIFrame);
  const opts = Object.assign({}, stickyOpts, {iframe: $("#js-video")});
  nowPlayingMessage($trigger);
  setupPlayer(opts);
}
/**
 * Setup players for respective video sources
 * @param  {jQuery} $el - iframe of video to track
 * @param  {string} string of video type to test source against
 */
const playerType = ($el, type) => {
  const src = $el.attr('src').toLowerCase();
  if (src.indexOf(type) !== -1) {
    return true;
  }
  return false;
};
/**
 * Load correct api base on url
 * @private
 * @param  {object} stickyOpts - object of sticky elements
 */
const loadAPI = (stickyOpts) => {
  let apiURL;
  let apiURL2;
  const {iframe} = stickyOpts;
  if (playerType(iframe, 'vimeo')) {
    apiURL = VIMEO_API_URL;
    apiURL2 = YOUTUBE_API_URL;
  } else if (playerType(iframe, 'youtube')) {
    apiURL = YOUTUBE_API_URL;
    apiURL2 = VIMEO_API_URL;
  }
  $.ajax({
    url: apiURL,
    cache: true,
    dataType: 'script',
  }).done(() => {
    setupPlayer(stickyOpts);
  });

  $.ajax({
      url: apiURL2,
      cache: true,
      dataType: 'script',
  });
};

/**
 * Initializes an toggleContent based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
export default function stickyVideo(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  const $stickyContainer = $(`.${CONTAINER_CLASS_NAME}`);
  const $stickWrap = $stickyContainer.find(`.${WRAP_CLASS_NAME}`);
  const $stickIFrame = $stickyContainer.find(`.${IFRAME_CLASS_NAME}`);
  const stickyOpts = {
    container: $el,
    videoContainer: $stickyContainer,
    wrap: $stickWrap,
    iframe: $stickIFrame,
  };
  loadAPI(stickyOpts);
};
/**
 * Add event for YouTube API ready method
 */
window.onYouTubeIframeAPIReady = () => {
  $(window).trigger('youtubeLoaded');
  window.youtubeLoaded = true;
};
registerJQueryPlugin(PLUGIN_NAME, stickyVideo);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/sticky-video.js